import { apiRequestFactory } from "@/api/util";

import { AssetType } from "@/../../server/src/shared/webdist/assetType";
import { PostPropertyMap } from "@/../../server/src/shared/webdist/postProperties";
import { PostElementType } from "@/../../server/src/shared/webdist/postElementType";

const apiSpec = {
  "/post/publication/get": {
    required: ["publicationId", "postId"],
  },
  "/post/publication/list": {
    responseContent: "previewContent",
    required: ["ownerGroupId"],
    listResponse: "publications",
    attachToResponseItems: ["ownerGroupId"],
  },
  "/post/publication/view": {
    responseContent: "content",
    required: ["postId"],
  },
  "/post/publication/create": {
    required: ["postId"],
  },
  "/post/publication/search": {
    responseContent: "previewContent",
    required: [],
    listResponse: "publications",
  },
  "/post/publication/preview": {
    responseContent: "content",
    required: ["postId"],
  },
};

const typeSpec = {
  post: {
    properties: PostPropertyMap,
  },
};

// const apiRequest = apiRequestFactory(apiSpec);
const apiRequest = apiRequestFactory(apiSpec, typeSpec, null, "post", [
  {
    location: "assets",
    TypeMap: AssetType.map,
    variableTypeName: "assetType",
  },
  {
    location: "elements",
    TypeMap: PostElementType.map,
    variableTypeName: "elementType",
  },
]);

export default {
  get: (options, args) => apiRequest(options, "/post/publication/get", args),
  list: (options, args) => apiRequest(options, "/post/publication/list", args),
  view: (options, args) => apiRequest(options, "/post/publication/view", args),
  create: (options, args) => apiRequest(options, "/post/publication/create", args),
  search: (options, args) => apiRequest(options, "/post/publication/search", args),
  preview: (options, args) => apiRequest(options, "/post/publication/preview", args),
};
